import { Component, OnInit, signal, computed } from '@angular/core';
import { TicketType } from 'src/app/models/ticketTypeModels';

import {  Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { loadTicketTypes } from 'src/app/core/store/ticket-types/ticket-types.actions';
import { BaseComponent } from 'src/app/core/abstracts/baseComponent';
import { Router } from '@angular/router';

@Component({
    selector: 'app-ticket-types-list',
    templateUrl: './ticket-types-list.component.html',
    styleUrls: ['./ticket-types-list.component.scss'],
    standalone: false
})
export class TicketTypesListComponent  extends BaseComponent implements OnInit {
  ticketTypes: TicketType[];
  loading;

  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });
  constructor(private store: Store<State>, private router: Router) {
    super();  
  }

  ngOnInit(): void {
    this.subs.push(
        this.store.select(s => s.ticketTypesState).subscribe(ticketTypesState => {
            if (ticketTypesState){
                this.ticketTypes = ticketTypesState.ticketTypes || [];
                this.totalRecords.set(ticketTypesState.ticketTypes.length);
            }
            this.loading = ticketTypesState.loading;
        })
    );
    this.store.dispatch(loadTicketTypes());
  }

  getCustomFields(ticketType: TicketType){
    return ticketType.customFields.filter(x => x.deletedDate == null);
  }

  editTicketType(ticketTypeId: number): void {
    this.router.navigate(['/ticket-types/edit', ticketTypeId]);
  }
}
